import { PREFERENCES_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import preferencesTypes from '../constants/preferencesTypes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

const reset_preferences = () => {
  return {
    type: preferencesTypes.reset
  }
}

const reset_preference_errors = () => {
  return {
    type: preferencesTypes.reset_errors
  }
}

// INDEX
const preferences_index_request = () => {
  return {
    type: preferencesTypes.index.request
  }
}

const preferences_index_success = (response) => {
  return {
    type: preferencesTypes.index.success,
    payload: response.data
  }
}

const preferences_index_failure = (messages) => {
  return {
    type: preferencesTypes.index.failure,
    payload: messages
  }
}

const preferences_index = () => {
  return function (dispatch) {
    // Before Request
    dispatch(preferences_index_request())

    // Request
    axios.get(
      PREFERENCES_ROUTES.index
    ).then( response => {
      // success
      dispatch( preferences_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching preferences."]
      }
      dispatch( preferences_index_failure(errors))
    })
  }
}

// UPDATE
const update_preference_request = () => {
  return {
    type: preferencesTypes.update.request
  }
}

const update_preference_success = (response) => {
  return {
    type: preferencesTypes.update.success,
    payload: response.data
  }
}

const update_preference_failure = (messages) => {
  return {
    type: preferencesTypes.update.failure,
    payload: messages
  }
}

const update_preference = (preference_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_preference_request())

    // Request
    axios.patch(
      formatRoute(PREFERENCES_ROUTES.update, {id: preference_id}),
      values
    ).then( response => {
      // success
      dispatch( update_preference_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating preference."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( update_preference_failure(errors))
    })
  }

}

export {
  reset_preferences,
  reset_preference_errors,
  preferences_index,
  update_preference
}



// WEBPACK FOOTER //
// ./src/js/actions/preferencesActions.js